<script setup>
import {VOnClickOutside} from "@/directives/clickOutside";
import {defineProps, ref} from "vue";
import ChevronDown from "@/components/icons/ChevronDown.vue";

const props = defineProps({
  cell: {
    type: String,
    default: ""
  },
  items: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(["save-dropdown-cell"]);

const isShowDropdown = ref(false);

const openDropdown = () => {
  isShowDropdown.value = true;
};

const closeDropdown = () => {
  isShowDropdown.value = false;
};

const saveDropdownCell = (val) => {
  closeDropdown();
  emit("save-dropdown-cell", val);
  setTimeout(() => closeDropdown(), 0);
};

</script>

<template>
  <div
    class="dropdown-cell"
    @click="openDropdown"
  >
    <div class="dropdown-cell__selected">
      <span>{{ props.cell }}</span>
      <ChevronDown class="dropdown-cell__icon" />
    </div>
    <div
      v-show="isShowDropdown"
      v-on-click-outside="closeDropdown"
      class="dropdown-cell-list"
    >
      <div
        v-for="item in props.items"
        :key="item"
        class="dropdown-cell-list__item"
        :class="{'dropdown-cell-list__item_active': item === props.cell}"
        @click="saveDropdownCell(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.dropdown-cell {
  position: relative;
  &__selected {
    display: flex;
    gap: 4px;
    align-items: center;
    & span::first-letter {
      text-transform: uppercase;
    }
  }

  &-list {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 4px;
    left: 10px;
    top: 45px;
    width: 120px;
    box-shadow: 1px 2px 10px 0 #131E2726;
    background: #FFFFFF;
    z-index: 2;
    padding: 6px;
    border-radius: 8px;

    &__item {
      padding: 6px 14px;
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
      color: #212327;
      &::first-letter {
        text-transform: uppercase;
      }

      &:hover {
        background: #eef1f4;
      }

      &_active {
        background: #e0f0ff;
        color: #1f9aff;

        &:hover {
          background: #e0f0ff;
        }
      }
    }
  }

  &__icon {
    width: 14px;
    height: 14px;
    margin-left: 8px;
    cursor: pointer;
    user-select: none;
  }
}

</style>